import { useState } from "react";
import { ScrollView, Pressable, View, Text, TextInput } from "react-native";
import { useRouter, useLocalSearchParams } from "expo-router";
import { useClub } from "@/contexts/ClubContext";
import { useMembers } from "@/hooks/useMembers";
import { colors, radius } from "@/lib/theme";
import ContentWidth from "@/components/ContentWidth";
import { setPick } from "@/lib/pickerMailbox";

function initials(name: string): string {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export default function PickCaptainScreen() {
  const router = useRouter();
  const params = useLocalSearchParams<{ field: "captain" | "viceCaptain"; selectedId?: string; key: string }>();
  const { club } = useClub();
  const { members } = useMembers(club?.id);
  const [search, setSearch] = useState("");

  const filtered = members.filter((m) =>
    m.displayName?.toLowerCase().includes(search.toLowerCase())
  );

  const pick = (id: string, name: string) => {
    setPick({ id, name, field: params.field, key: params.key });
    router.back();
  };

  const clear = () => {
    setPick({ id: "", name: "", field: params.field, key: params.key });
    router.back();
  };

  return (
    <View style={{ flex: 1, backgroundColor: colors.bg }}>
      <ContentWidth>
        <View style={{ padding: 16 }}>
          <TextInput
            placeholder="Search members"
            placeholderTextColor={colors.inkMuted}
            value={search}
            onChangeText={setSearch}
            style={{
              backgroundColor: colors.white,
              borderRadius: radius.md,
              borderWidth: 1,
              borderColor: colors.line,
              paddingHorizontal: 14,
              paddingVertical: 12,
              fontSize: 15,
              color: colors.ink,
            }}
          />
        </View>

        <ScrollView keyboardShouldPersistTaps="handled">
          {params.selectedId ? (
            <Pressable onPress={clear}>
              <View style={{ padding: 16, borderBottomWidth: 1, borderBottomColor: colors.line }}>
                <Text style={{ fontSize: 15, fontWeight: "700", color: colors.danger }}>Clear current selection</Text>
              </View>
            </Pressable>
          ) : null}

          {filtered.map((m) => {
            const selected = m.id === params.selectedId;
            return (
              <Pressable key={m.id} onPress={() => pick(m.id, m.displayName)}>
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    padding: 14,
                    paddingHorizontal: 16,
                    backgroundColor: selected ? colors.brand50 : colors.white,
                    borderBottomWidth: 1,
                    borderBottomColor: colors.line,
                  }}
                >
                  <View
                    style={{
                      width: 38,
                      height: 38,
                      borderRadius: 19,
                      backgroundColor: colors.brand50,
                      borderWidth: 1.5,
                      borderColor: colors.brandLight,
                      alignItems: "center",
                      justifyContent: "center",
                      marginRight: 12,
                    }}
                  >
                    <Text style={{ fontSize: 13, fontWeight: "800", color: colors.brandDark }}>
                      {initials(m.displayName)}
                    </Text>
                  </View>
                  <View style={{ flex: 1 }}>
                    <Text style={{ fontSize: 15, fontWeight: selected ? "800" : "600", color: selected ? colors.brandDark : colors.ink }}>
                      {m.displayName}
                    </Text>
                    <Text style={{ fontSize: 12, color: colors.inkMuted, marginTop: 2, textTransform: "capitalize" }}>
                      {m.role}
                    </Text>
                  </View>
                  {selected && <Text style={{ fontSize: 18, color: colors.brand }}>✓</Text>}
                </View>
              </Pressable>
            );
          })}
        </ScrollView>
      </ContentWidth>
    </View>
  );
}
